import React from 'react';
import { LuBookOpen } from 'react-icons/lu';

/** Standard notebook tile — book icon (no color/emoji picker). */
export default function NotebookAvatar({ size = 'md' }) {
  return (
    <div className={`learn-nb-avatar learn-nb-avatar--notebook learn-nb-avatar--${size}`} aria-hidden>
      <LuBookOpen className="learn-nb-avatar-book" />
    </div>
  );
}
